import React from 'react'
import { motion } from 'framer-motion' 
import { Container, Col, Row } from 'react-bootstrap'
import useFetchData from '../../hooks/use-fetch-data'
import { Link } from 'react-router-dom';
import './Whyhire.css'

function WhyHire() {
  const { data } = useFetchData([]);

  console.log(data);

  if(!data) return null;

  return (
    <div className='why-cont--content py-6'> 
      { data.map(index => index.id == 7  ? (
        <Container>         
            <Row>
              <Col md={8} style={{ position: 'relative'}} key={index.id}>
              <motion.div
              initial={{ opacity: 0, y:50 }}
              whileInView={{opacity: 1, y:0, transition: { duration: 0.5, delay: 0.25}}}
              className="header-title" dangerouslySetInnerHTML={{__html: index.acf.title}}/>

              <div className="text-start" style={{maxWidth: '100%', width: '700px', height: '99%'}} dangerouslySetInnerHTML={{__html: index.acf.why_hire_me_content}}/>
                <Link to="/work" style={{ position: 'absolute', left: '0', bottom:'0'}} className="cta-primary-service">View Work</Link>
              </Col>
                <Col md={4}>
                  <img src={index.acf.image} width="200" height="450px" />
                </Col>
              </Row> 
        </Container>
      ) : null 
      )
      }
    </div>
  )
}

export default WhyHire